export const CommentQueryKey = {
    comments: (entityId: string) => [entityId, 'comments'],
}
